import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';

const formatMoney = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '—';
    return `${amount.toLocaleString('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    })} MAD`;
};

const displayText = (value) => (
    value === null || value === undefined || value === '' ? '—' : value
);

const ResultatForm = ({ result }) => {
    const { t } = useTranslation('translation');

    return (
        <Card className="evaluation-result-card">
            <CardBody>
                <div className="evaluation-result-header">
                    <span className="evaluation-result-header-icon">
                        <i className="ri-line-chart-line"></i>
                    </span>
                    <div>
                        <h5>Résultat de l’évaluation</h5>
                        <p>{result ? 'Calcul terminé avec succès' : 'En attente du calcul'}</p>
                    </div>
                    <span className={`evaluation-result-status ${result ? 'ready' : ''}`}>
                        <i className={result ? 'ri-checkbox-circle-fill' : 'ri-time-line'}></i>
                        {result ? 'Disponible' : 'À calculer'}
                    </span>
                </div>

                {!result ? (
                    <div className="evaluation-result-empty">
                        <span><i className="ri-calculator-line"></i></span>
                        <h6>Aucun résultat disponible</h6>
                        <p>Sélectionnez un véhicule complet, puis lancez l’évaluation pour afficher le détail du calcul.</p>
                    </div>
                ) : (
                    <>
                        <div className="evaluation-result-hero">
                            <span>{t('vvinale.VVADEavecCorrectifTotal')}</span>
                            <strong>{formatMoney(result.vvadEavecCorrectifTotal)}</strong>
                            <div>
                                <small>Valeur finale corrigée</small>
                                {result.reform && <em>{result.reform}</em>}
                            </div>
                        </div>

                        <div className="evaluation-result-kpis">
                            <div>
                                <span>Valeur sans correctif</span>
                                <strong>{formatMoney(result.vvadEsansCorrectif)}</strong>
                            </div>
                            <div>
                                <span>{t('vvinale.epaveObtenueAssureur')}</span>
                                <strong>{formatMoney(result.epaveObtenueAssureur)}</strong>
                            </div>
                            <div>
                                <span>{t('vvinale.differenceValeurs')}</span>
                                <strong>{formatMoney(result.differenceValeurs)}</strong>
                            </div>
                            <div>
                                <span>Valeur arrondie</span>
                                <strong>{formatMoney(result.arrondie)}</strong>
                            </div>
                        </div>

                        <div className="evaluation-result-section-title">
                            <i className="ri-function-line"></i>
                            Détail des correctifs
                        </div>

                        <div className="evaluation-result-breakdown">
                            <div>
                                <span className="evaluation-result-step">1</span>
                                <div>
                                    <small>{t('vvinale.courbeDepreciation')}</small>
                                    <strong className="calculation-curve">{displayText(result.courbeDepreciation)}</strong>
                                </div>
                            </div>
                            <div>
                                <span className="evaluation-result-step">2</span>
                                <div>
                                    <small>{t('vvinale.correctifEtatVehicule')}</small>
                                    <strong>{displayText(result.correctifEV)} · {formatMoney(result.correctifEtatVehicule)}</strong>
                                </div>
                            </div>
                            <div>
                                <span className="evaluation-result-step">3</span>
                                <div>
                                    <small>{t('vvinale.correctifKilometrique')}</small>
                                    <strong>{displayText(result.correctifKm)} · {formatMoney(result.correctifKilometrique)}</strong>
                                </div>
                            </div>
                            <div>
                                <span className="evaluation-result-step">4</span>
                                <div>
                                    <small>{t('vvinale.correctifTotal')}</small>
                                    <strong>{displayText(result.correctifTotalS)} · {formatMoney(result.correctifTotal)}</strong>
                                </div>
                            </div>
                        </div>

                        {result.montantCommercial !== null && result.montantCommercial !== undefined && (
                            <div className="evaluation-commercial-value">
                                <span>
                                    <i className="ri-percent-line"></i>
                                    {t('vehiculef.coefCommercial')}
                                </span>
                                <strong>{formatMoney(result.montantCommercial)}</strong>
                            </div>
                        )}
                    </>
                )}
            </CardBody>
        </Card>
    );
};

export default ResultatForm;
